import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Download } from "lucide-react";
import "../styles/Header.css";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => {
    scrollToTop();
    setMenuOpen(false); // Close menu on route change
  }, [location.pathname]);

  const handleCatalogueDownload = () => {
    try {
      // Create a link element to trigger download
      const link = document.createElement("a");
      link.href = "/Parwah_Catalogue.pdf";
      link.download = "Parwah_Catalogue.pdf";

      // Add error handling for file not found
      link.onerror = () => {
        alert(
          "Catalogue file not found. Please ensure the PDF file is placed in the public folder."
        );
      };

      // Check if file exists before attempting download
      fetch("/Parwah_Catalogue.pdf")
        .then((response) => {
          if (response.ok) {
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            alert(
              "Catalogue file not found. Please ensure the PDF file is placed in the public folder."
            );
          }
        })
        .catch((error) => {
          console.error("Error downloading catalogue:", error);
          alert(
            "Catalogue file not found. Please ensure the PDF file is placed in the public folder."
          );
        });
    } catch (error) {
      console.error("Error in download function:", error);
      alert("Error downloading catalogue. Please try again.");
    }
  };

  return (
    <header>
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img src="/images/parwah png .png" alt="Parwah Industries Logo" />
          </Link>
        </div>
        <nav className={menuOpen ? "open" : ""}>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/products">Our Brands</Link>
            </li>
            <li>
              <Link to="/vision">Our Vision</Link>
            </li>
            <li>
              <Link to="/quality">Quality</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <button
                onClick={handleCatalogueDownload}
                className="catalogue-btn"
              >
                <Download size={16} />
                Catalogue
              </button>
            </li>
          </ul>
        </nav>
        <div
          className="mobile-menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <Menu size={32} />
        </div>
      </div>
    </header>
  );
};

export default Header;
